var map = {
	"./number-0.png": 7244,
	"./number-1.png": 9509,
	"./number-2.png": 7406,
	"./number-3.png": 9895,
	"./number-4.png": 280,
	"./number-5.png": 497,
	"./number-6.png": 9386,
	"./number-7.png": 3491,
	"./number-8.png": 3268,
	"./number-9.png": 7165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1297;